// extracted by mini-css-extract-plugin
var _1 = "FolderComponent_content__0e2a1";
var _2 = "FolderComponent_icon__fed7c";
var _3 = "FolderComponent_root__eff4f";
export { _1 as "content", _2 as "icon", _3 as "root" }
